import { EncryptionKeysProvider } from '@dialectlabs/sdk';
export class DialectSolanaWalletAdapterEncryptionKeysProvider extends EncryptionKeysProvider {
    constructor(dialectWalletAdapter) {
        super();
        this.dialectWalletAdapter = dialectWalletAdapter;
    }
    isAvailable() {
        return this.dialectWalletAdapter.canEncrypt;
    }
    getFailSafe() {
        return this.dialectWalletAdapter.canEncrypt
            ? this.dialectWalletAdapter.diffieHellman()
            : Promise.resolve(null);
    }
    getFailFast() {
        return this.dialectWalletAdapter.diffieHellman();
    }
}
//# sourceMappingURL=encryption-keys-provider.js.map